import React from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router'
import Modal from '../../../components/common/Modal'
import { api } from '../../../configs/api'
import { CompanyDetailType, useCompany } from '../../../context/CompanyContext'

const CompanyDelete = ({
    open,
    handleClose,
    data
}: {
    open: boolean
    handleClose: () => void
    data: CompanyDetailType | null
}) => {
    const { loadCompanies } = useCompany()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)
    const navigate = useNavigate()

    const handleDelete = async () => {
        if (!data) return
        const id = data.company.id
        if (!id) {
            toast.error('Empresa não encontrada!')
            return
        }

        try {
            const response = await fetch(`${api}company/delete`, {
                method: 'POST',
                body: JSON.stringify({ companyID: id })
            })

            const result = await response.json()
            if (!result.success) {
                toast.error(result.message || 'Erro ao excluir a empresa!')
                return
            }

            loadCompanies()
            navigate(-1)
            toast.success('Empresa excluída com sucesso!')
        } catch (error) {
            console.log(error)
        } finally {
            handleClose()
        }
    }

    if (!open || !data) return null

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Excluir Empresa'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete={data.business.length === 0}
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDelete)}>
                <div className='text-gray-800 dark:text-white/90 text-sm'>
                    {/* Pode excluir */}
                    {data.business.length == 0 && (
                        <p>
                            Tem certeza que deseja exluir a empresa{' '}
                            <strong className='text-error-400'>
                                {data.company.name} #{data.company.id}
                            </strong>{' '}
                            ? Esta ação é irreversível.
                        </p>
                    )}

                    {/* Não é possível excluir */}
                    {data.business.length > 0 && (
                        <p>
                            Não é possível excluir a empresa{' '}
                            <strong className='text-error-400'>
                                {data.company.name} #{data.company.id}
                            </strong>{' '}
                            pois ela possui{' '}
                            <span className='font-bold text-error-400'>
                                {data.business.length}
                                {data.business.length == 1 ? ' negócio vinculado ' : ' negócios vinculados '}
                            </span>
                            a ela .
                        </p>
                    )}
                </div>
            </form>
        </Modal>
    )
}

export default CompanyDelete
